import signImg from '../../assets/images/Login.jpg'
import logo from '../../assets/images/h_logo.png'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import React, { useState, useEffect, useRef } from "react";
import { API_STATUS } from '../../constants';
import { loginApi } from '../../apis/login/user_login';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { remove_user_login, set_user_login } from '../../redux/VerifyLogin';
import SetLoginToken from '../../utils/setlogintoken';
import { FgtUsernameApi } from '../../apis/login/fgt_username_api';
import { FgtPasswordApi } from '../../apis/login/fgt_password_api';
import { VerifyOtpApi } from '../../apis/login/verify_otp_api';
import { PassResetApi } from '../../apis/login/pass_reset_api';
import { VerifySignupOtp } from '../../apis/login/verify_signup_otp';

export default function SignupOtp({ submitData, setStep, setPanV, mobile, vcode }) {

    const dispatch = useDispatch();
    const authState = useSelector(state => state.checkuserlogin);
    const navigate = useNavigate();

    const [otpApi, setOtpApi] = useState(API_STATUS);

    const et1 = useRef();
    const et2 = useRef();
    const et3 = useRef();
    const et4 = useRef();
    const et5 = useRef();
    const et6 = useRef();

    const [otp1, setOtp1] = useState('');
    const [otp2, setOtp2] = useState('');
    const [otp3, setOtp3] = useState('');
    const [otp4, setOtp4] = useState('');
    const [otp5, setOtp5] = useState('');
    const [otp6, setOtp6] = useState('');
    const [otpErr, setOtpErr] = useState('');

    const submitOtp = () => {
        const otp = otp1.toString() + otp2.toString() + otp3.toString() + otp4.toString() + otp5.toString() + otp6.toString();
        const body = { 'username': vcode, 'otp': otp }
        VerifySignupOtp(body, setOtpApi);
    }

    useEffect(() => {
        console.log(otpApi);
        if (!otpApi.isError && !otpApi.isLoader) {
            if (otpApi.data != null) {
                const res = otpApi.data;
                if (res.status === 1) {
                    setPanV(true);
                    setStep(1);
                    submitData();
                } else {
                    setOtpErr("Wroung OTP");
                }
            }
        } else if (otpApi.isError) {
            setOtpErr("Network error");
        }
    }, [otpApi]);



    return <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
            {
                otpErr !== "" &&
                <div className='alert text-danger' style={{ textAlign: 'center' }}>
                    <strong>Failed !!</strong><br />
                    {otpErr}
                </div>
            }
            <div className="text-sm mb-2">OTP is send to {mobile} number.</div>
            <div className='text-lg text-blue-600'>Enter  OTP</div>
            <div className='flex' style={{ justifyContent: 'center' }}>
                <input
                    ref={et1}
                    onChange={(v) => {
                        setOtp1(v.target.value);
                        if (v.target.value !== "") {
                            et2.current.focus();
                        }
                    }}
                    className="form-control" type="text" style={{ width: 50 }} />
                <input
                    ref={et2}
                    onChange={(v) => {
                        setOtp2(v.target.value);
                        if (v.target.value !== "") {
                            et3.current.focus();
                        } else {
                            et1.current.focus();
                        }
                    }}
                    className="form-control" type="text" style={{ width: 50 }} />
                <input
                    ref={et3}
                    onChange={(v) => {
                        setOtp3(v.target.value);
                        if (v.target.value !== "") {
                            et4.current.focus();
                        } else {
                            et2.current.focus();
                        }
                    }}
                    className="form-control" type="text" style={{ width: 50 }} />
                <input
                    ref={et4}
                    onChange={(v) => {
                        setOtp4(v.target.value);
                        if (v.target.value !== "") {
                            et5.current.focus();
                        } else {
                            et3.current.focus();
                        }
                    }}
                    className="form-control" type="text" style={{ width: 50 }} />
                <input
                    ref={et5}
                    onChange={(v) => {
                        setOtp5(v.target.value);
                        if (v.target.value !== "") {
                            et6.current.focus();
                        } else {
                            et4.current.focus();
                        }
                    }}
                    className="form-control" type="text" style={{ width: 50 }} />
                <input
                    ref={et6}
                    onChange={(v) => {
                        setOtp6(v.target.value);
                        if (v.target.value === "") {
                            et5.current.focus();
                        }
                    }}
                    className="form-control" type="text" style={{ width: 50 }} />
            </div>
            {
                otp1 !== "" && otp2 !== "" && otp3 !== "" && otp4 !== "" && otp5 !== "" && otp6 !== "" &&

                <div className="row mt-4">
                    <div className="col-md-12">
                        {
                            otpApi.isLoader &&
                            <div className="spinner-border text-primary" role="status">
                            </div>
                        }
                        {
                            !otpApi.isLoader &&

                            <button
                                onClick={() => {
                                    submitOtp();
                                }}
                                type="button" className="button_slide slide_right orange">Submit OTP</button>
                        }
                    </div>
                </div>
            }
            <div className="row mt-5">
                <div className='col' style={{ textAlign: 'center' }}>
                    <button
                        onClick={() => setStep(2)}
                        className='btn btn-outline-danger'>Back</button>
                </div>
            </div>
        </div>
    </div>
}